export const  GET_TUTOR_ONE_2_ONE_REQUEST='tutorOne2OneReducer/GET_TUTOR_ONE_2_ONE_REQUEST';
export const  GET_TUTOR_ONE_2_ONE_SUCCESS='tutorOne2OneReducer/GET_TUTOR_ONE_2_ONE_SUCCESS';
export const  GET_TUTOR_ONE_2_ONE_FAILED='tutorOne2OneReducer/GET_TUTOR_ONE_2_ONE_FAILED';